module.exports = __webpack_public_path__ + "img/sangli_sujata.29334b1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/sangli_sujata.jpeg
// module id = 2040
// module chunks = 1